import { Checkbox, Form, Select } from "antd";
import { sanitizePercent2Input } from "tm-shared/utils";

import { MultiselectContainer } from "@/components/Layout/Styled";
import { useAppSelector } from "@/hooks/redux";
import { ContractFormValues } from "@/types/form";
import { handleFocus } from "@/utils/dom/handleFocus";

import { StyledInputNumber } from "../../Styled";

export const RetroBonusPercentage = () => {
    const { options } = useAppSelector((s) => s.work);
    const form = Form.useFormInstance<ContractFormValues>();

    const finGroups = Form.useWatch("finGroups", form);
    const isAllFinGroups = Form.useWatch("isAllFinGroups", form);

    const handleToggleAll = (checked: boolean) => {
        form.setFieldValue("isAllFinGroups", checked);

        if (checked) {
            form.setFieldValue("finGroups", []);
        }

        form.validateFields(["finGroups"]).catch(() => void 0);
    };

    const handleSelectGroups = (values: string[]) => {
        form.setFieldValue("finGroups", values);

        if (values.length > 0 && isAllFinGroups) {
            form.setFieldValue("isAllFinGroups", false);
        }

        form.validateFields(["finGroups"]).catch(() => void 0);
    };

    return (
        <>
            <Form.Item<ContractFormValues>
                name="isAllFinGroups"
                valuePropName="checked"
            >
                <Checkbox
                    disabled={!!finGroups?.length}
                    onChange={(e) => handleToggleAll(e.target.checked)}
                >
                    Всі групи товарів
                </Checkbox>
            </Form.Item>

            <MultiselectContainer $minHeight="48px">
                <Form.Item<ContractFormValues>
                    name="finGroups"
                    label="Групи товарів"
                    rules={[
                        {
                            required: !isAllFinGroups,
                            message: "Оберіть хоча б один товар",
                        },
                    ]}
                >
                    <Select
                        mode="multiple"
                        allowClear
                        style={{ width: "100%" }}
                        placeholder="Оберіть групи товарів"
                        options={options.finGroups}
                        disabled={isAllFinGroups}
                        onChange={handleSelectGroups}
                    />
                </Form.Item>
            </MultiselectContainer>

            <Form.Item<ContractFormValues>
                name="discountInPercentage"
                label="Вкажіть % знижки"
                rules={[{ required: true, message: "Вкажіть суму витрат" }]}
            >
                <StyledInputNumber
                    min={0}
                    onFocus={handleFocus}
                    textAlign="left"
                    inputMode="numeric"
                    placeholder="00"
                    style={{ width: "100%" }}
                    parser={sanitizePercent2Input}
                />
            </Form.Item>
        </>
    );
};
